import React from 'react';
import { useIntl } from 'react-intl';

import { Radio } from '../../../../forms';
import { Paragraph } from '../../../../typography';

import './conversation-type.scss';

export const CONVERSATION_TYPES = {
    INDIVIDUAL: 'individual',
    GROUP: 'group'
};

const conversationTypeOptions = [
    {
        value: CONVERSATION_TYPES.INDIVIDUAL,
        title: 'Conversa individual',
        description: 'Uma conversa separada com cada usuário escolhido'
    },
    {
        value: CONVERSATION_TYPES.GROUP,
        title: 'Conversa em grupo',
        description: 'Uma única conversa com todos os participantes'
    }
];

const ConversationType = ({ conversationType, setConversationType }) => {
    const intl = useIntl();

    return (
        <div className="p-1 internal-conversation-type">
            <Paragraph>{intl.formatMessage({ id: "Tipo de conversa:" })}</Paragraph>
            {conversationTypeOptions.map(option => (
                <Radio
                    key={option.value}
                    id={`internal-conversation-type-${option.value}`}
                    name="internalConversationType"
                    className="internal-conversation-type-option"
                    value={option.value}
                    checked={conversationType === option.value}
                    onChange={() => setConversationType(option.value)}
                    label={
                        <span className="internal-conversation-type-label">
                            <strong>{intl.formatMessage({ id: option.title })}</strong>
                            <small>{intl.formatMessage({ id: option.description })}</small>
                        </span>
                    }
                />
            ))}
        </div>
    );
};

export default React.memo(ConversationType);
